export default __webpack_public_path__ + "static/media/history-bg-small.0af8efd1.webp";